import api from './apiConfig';

const processTypeService = {
  getAll: async () => {
    try {
      const response = await api.get('/processes/types');
      return response.data;
    } catch (error) {
      console.error('Error fetching process types:', error);
      throw error;
    }
  }
};

export default processTypeService; 